import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { notesAndImagesVisibilityOptions } from './constants'
import * as Styles from './styles'

const RejectedProductsSection = ({ notesAndImagesVisibilityValue, onChangeNotesAndImageVisibility }) => {
  const { t } = useTranslation()

  return (
    <Styles.Section>
      <Text type="titleM">{t('Productos rechazados')}</Text>
      <Text type="bodyMRegular">
        {t('Define cual será el comportamiento de las notas e imágenes añadidas para los productos rechazados')}
      </Text>
      <ComboBox
        label={t('Visibilidad de notas e imágenes productos rechazados')}
        menuItems={notesAndImagesVisibilityOptions.map(o => ({ ...o, label: t(o.label) }))}
        value={notesAndImagesVisibilityValue}
        handleChange={e => onChangeNotesAndImageVisibility(e.target.value)}
      />
    </Styles.Section>
  )
}

export default RejectedProductsSection
